var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "label-width": "80px",
          "default-sort": _vm.defaultSort,
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: false,
          "auto-fetch": false,
          "right-toolbar-hide": true,
          "search-btn-hide": true,
        },
        on: {
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
          "sort-change": _vm.sortChange,
          afterFetchOriginalData: _vm.afterFetchOriginalData,
        },
        scopedSlots: _vm._u([
          {
            key: "tableColumn",
            fn: function () {
              return [
                _c("vxe-column", {
                  attrs: { type: "expand", width: "40" },
                  scopedSlots: _vm._u([
                    {
                      key: "content",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c(
                            "div",
                            { staticStyle: { padding: "10px 20px" } },
                            [
                              _c(
                                "vxe-table",
                                {
                                  attrs: {
                                    data: row.childDataList,
                                    "empty-text": _vm.$t("table.emptyText"),
                                  },
                                },
                                [
                                  _c("vxe-column", {
                                    attrs: {
                                      field: "company",
                                      title: _vm.$t("billingPage.Company"),
                                    },
                                  }),
                                  _c("vxe-column", {
                                    attrs: {
                                      field: "income",
                                      title: _vm.$t("billingPage.Income"),
                                    },
                                  }),
                                  _c("vxe-column", {
                                    attrs: {
                                      field: "cost",
                                      title: _vm.$t("billingPage.Cost"),
                                    },
                                  }),
                                  _c("vxe-column", {
                                    attrs: {
                                      field: "grossProfit",
                                      title: _vm.$t("billingPage.GrossProfit"),
                                    },
                                  }),
                                  _c("vxe-column", {
                                    attrs: {
                                      field: "profitMargin",
                                      title: _vm.$t("billingPage.ProfitMargin"),
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    _c("vxe-table-column", {
                      key:
                        "col_" +
                        index +
                        "_" +
                        col.prop +
                        "_" +
                        (col.width || "auto"),
                      attrs: {
                        field: col.prop,
                        sortable: "",
                        prop: col.prop,
                        label: col.label,
                        width: col.width || "auto",
                        fixed: col.fixed || false,
                        align: "center",
                        "class-name": "item",
                        title: col.label,
                      },
                    }),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }